import { FunctionComponent } from "react";
import { ChatMessage } from "types/types";
import { Toast, ToastBody, ToastTitle } from '@fluentui/react-components';

interface ChatMessagesProps {
    history: ChatMessage[];
    onCopyToPrompt?: (content: string) => void;
    dispatchToast: (content: React.ReactElement, options?: { intent?: 'success' | 'error' | 'warning' | 'info'; timeout?: number }) => void;
}

export const ChatMessages: FunctionComponent<ChatMessagesProps> = ({ history, onCopyToPrompt, dispatchToast }) => {
    const handleCopyToPrompt = (message: string) => {
        // Strip HTML tags to get plain text
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = message;
        const plainText = tempDiv.textContent || tempDiv.innerText || '';
        
        if (onCopyToPrompt) {
            onCopyToPrompt(plainText);
        }
    };

    const handleCopyToClipboard = async (message: string) => {
        // Strip HTML tags to get plain text
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = message;
        const plainText = tempDiv.textContent || tempDiv.innerText || '';
        
        try {
            await navigator.clipboard.writeText(plainText);
            dispatchToast(
                <Toast>
                    <ToastTitle>Copied to clipboard</ToastTitle>
                    <ToastBody>Content has been copied to your clipboard</ToastBody>
                </Toast>,
                { intent: "success", timeout: 2000 }
            );
        } catch (err) {
            console.error('Failed to copy to clipboard:', err);
            dispatchToast(
                <Toast>
                    <ToastTitle>Copy failed</ToastTitle>
                    <ToastBody>Failed to copy content to clipboard</ToastBody>
                </Toast>,
                { intent: "error", timeout: 3000 }
            );
        }
    };

    return (
        <>
            {history.map((item, index) => (
                <ul key={index} className={item.role + " bubble"} >
                    <li></li>
                    <li className="messageContent">
                        <div dangerouslySetInnerHTML={{ __html: item.message}}></div>
                        {item.role === 'User' && onCopyToPrompt && (
                            <button 
                                className="copy-button material-symbols-rounded"
                                onClick={() => handleCopyToPrompt(item.message)}
                                title="Copy to prompt"
                            >
                                edit
                            </button>
                        )}
                        {item.role === 'Model' && (
                            <button 
                                className="copy-button material-symbols-rounded"
                                onClick={() => handleCopyToClipboard(item.message)}
                                title="Copy to clipboard"
                            >
                                content_copy
                            </button>
                        )}
                    </li>
                </ul>
            ))}
        </>
    );
}